import React, { FC } from "react";
import { FaStar } from "react-icons/fa6";
import { NextImage } from "@/components/NextImage";
import { Typography } from "@/components/Typography";
import { SocialProofProps } from "./types";

import "./styles.scss";

export const SocialProof: FC<SocialProofProps> = ({ socialProof, className }) => {
  if (!socialProof) return null;

  return (
    <div
      className={`social-proof ${className || ""}`.trim()}
      id="social-proof"
    >
      <div className="social-proof__avatars">
        {socialProof.avatars?.map((avatar, index) => (
          <NextImage
            key={index}
            src={avatar.image}
            alt={avatar.alt}
            width={avatar.width}
            height={avatar.height}
          />
        ))}
      </div>
      <div className="social-proof__content">
        <div className="social-proof__stars">
          {Array.from({ length: 5 }).map((_, index) => (
            <FaStar key={index} />
          ))}
        </div>
        <Typography
          Tag="p"
          classname="social-proof__text"
        >
          <span className="social-proof__text__strong">{socialProof.text_1}</span>{" "}
          {socialProof.text_2}
        </Typography>
      </div>
    </div>
  );
};
